/* eslint-disable max-len */
import React, { useContext } from 'react';
import { MediaContext } from '../../..';

const CommonVariableAndFunc = (data, setOptionsData, setAnchorEl) =>
{
	const { mediaState } = useContext(MediaContext);
	const mediaExt = {
		image : 'jpg',
		video : 'mp4'
	};
	const handleClose = () =>
	{
		setAnchorEl(null);
		setOptionsData({});
	};
	const handleOptions = (event:any, item:any) =>
	{
		if (mediaState?.selectedData?.length >= 1) return;
		setAnchorEl(event.currentTarget);
		setOptionsData(item);
	};
	const fileType:any = data?.media?.type?.split('/')[0] || 'blank';

	let extensionformat = data?.media?.key?.split('.').pop();

	extensionformat = extensionformat || (mediaExt[fileType] || 'doc');

	const documentCheck = [ 'doc', 'pdf', 'docx', 'ppt', 'pptx', 'xls', 'odt', 'ods', 'odp', 'rtf', 'txt' ];
	const defaultCheck = [ 'dot' ];

	return { handleClose, handleOptions, fileType, extensionformat, documentCheck, defaultCheck };
};

export default CommonVariableAndFunc;
